import { ClientsService } from '../services'

export default (fileData) => {
	return new Promise(resolve => {
		ClientsService.sendNewRequestFile(fileData)
			.then(response => resolve(response.data))
	})
}
